import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SystemPages } from '../../../../shared/enums/routerPaths.enum';
import { ModalInfo } from '../../../../shared/models';
import { patchState } from 'src/app/shared/utilities/object-patch';

export interface LimitationsModalData {
  title: string;
  description: string;
  action: LimitationModalActionData;
}

interface LimitationModalActionData {
  text: string;
  routerLink: SystemPages;
  routerParams?: { [key: string]: any };
}

@Component({
  selector: 'app-simple-limitation-modal',
  templateUrl: './simple-limitation-modal.component.html',
  styleUrls: ['./simple-limitation-modal.component.scss'],
  standalone: false,
})
export class SimpleLimitationModalComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<SimpleLimitationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LimitationsModalData,
  ) {}

  action: LimitationModalActionData | null = null;

  info: ModalInfo = {
    type: 'success-modal',
    closeModalBtnId: 'close-limitations-m',
    header: null,
    actions: {},
  };

  ngOnInit(): void {
    this.info = patchState(this.info, {
      header: {
        title: this.data.title,
        text: this.data.description,
      },
    });
    this.action = this.data.action;
  }

  closeModal(condition: boolean): void {
    this.dialogRef.close(condition);
  }
}
